import { create } from "zustand";
import {
	editTemplatesPlansContentPresetEditorContent,
	getTemplatesPlansContentPresetEditorContent,
} from "../services/plans-template-content-preset-editor.service";

const initialState = {
	planDetail: {},
	searchModel: "",
	isFiltering: false,
	searchLoading: false,
	searchResults: {
		organization_chapters: [],
		organization_chapter_contents: [],
		organization_goals: [],
		organization_requirements: [],
	},
	isSavingContent: [],
	roleSettings: null,
	isLoadingSave: false,
	selectedContent: null,
	chapterList: [],
	isConfirmOpen: false,
	courses: [],
	deleteConf: {},
	editorContext: {},
};

export const usePlanContentPresetsCompileStore = create((set, get) => ({
	...initialState,
	updateState: (newState) => set((state) => ({ ...newState })),

	/**
	 * Edit Content
	 * @param {*} editor
	 * @returns
	 */
	editContent: async (type = "editorjs", data, contentId, successCallback = () => {}) => {
		const isSavingContent = get().isSavingContent;
		const selectedContent = get().selectedContent;
		const planDetail = get().planDetail;

		isSavingContent.push("queue");

		const body = {
			templatePlan: planDetail.template_plan_id,
			contentPreset: planDetail.content_preset_id,
			templateChapterContent: contentId || selectedContent.content_id,
			...(type === "editorjs" && { editorjs: data }),
			...(type === "adminNote" && { admin_note: data }),
		};

		await editTemplatesPlansContentPresetEditorContent(body);

		set((state) => ({
			selectedContent: {
				...selectedContent,
				data: {
					...selectedContent.data,
					...(type === "editorjs" && { editorjs: data }),
					...(type !== "editorjs" && { admin_note: data }),
				},
			},
		}));

		isSavingContent.pop();

		set((state) => ({ isSavingContent }));

		successCallback();
	},

	/**
	 * Edit Content
	 * @param {*} editor
	 * @returns
	 */
	updateContentStatus: async (status) => {
		const isSavingContent = get().isSavingContent;
		const selectedContent = get().selectedContent;
		const chapterList = get().chapterList;
		const planDetail = get().planDetail;

		isSavingContent.push("queue");

		const body = {
			templatePlan: planDetail.template_plan_id,
			contentPreset: planDetail.content_preset_id,
			templateChapterContent: selectedContent.content_id,
			status: status,
		};

		await editTemplatesPlansContentPresetEditorContent(body);

		const findChapt = chapterList.find(
			(c) => c.content_id === selectedContent.data.organization_chapter_id
		);

		const findContent = findChapt.data.organization_contents.find(
			(c) =>
				c.content_id === selectedContent.content_id &&
				c.content_type === selectedContent.content_type
		);

		findContent.data.status = status;

		selectedContent.data.status = status;

		isSavingContent.pop();

		set((state) => ({
			selectedContent: { ...selectedContent },
			chapterList: [...chapterList],
			isSavingContent: isSavingContent,
		}));
	},

	/**
	 * Redirect Plan
	 */
	selectContentHandler: async (item) => {
		const planDetail = get().planDetail;
		if (item.content_type === "organization_chapter_content") {
			const res = await getTemplatesPlansContentPresetEditorContent({
				templatePlan: planDetail.template_plan_id,
				contentPreset: planDetail.content_preset_id,
				templateChapterContent: item.content_id,
			});
			item.data = res.data;
		}
		window.scroll(0, 0);

		set((state) => ({ selectedContent: item }));
	},

	/**
	 * Reset Data
	 */
	reset: () => set(JSON.parse(JSON.stringify(initialState))),
}));
